export const toCamelCase = (str: string): string =>
  str.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());

/** Formatta un numero con separatore migliaia italiano (punto). */
export function formatNumero(v: unknown): string {
  if (v === null || v === undefined) return '';
  const n = Number(v);
  if (isNaN(n)) return String(v);
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** "2025-11-29", "2025-11-29 00:00:00", "2025-11-29T00:00:00.000Z" → "29/11/2025" */
export function formatDate(v: string): string {
  if (!v) return '';
  const dateOnly = v.split(/[T ]/)[0]!;
  const [y, m, d] = dateOnly.split('-');
  return `${d}/${m}/${y}`;
}

/** Costruisce la query string di export dai filtri raccolti + filtro testo rapido. */
export function buildExportQuery(filtri: Record<string, string>, q?: string): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filtri)) {
    if (v) params.set(k, v);
  }
  if (q) params.set('q', q);
  return params.toString();
}

/**
 * Avvia il download di un file da URL same-origin senza aprire una nuova scheda.
 * Usa un anchor temporaneo: il browser scarica via Content-Disposition senza
 * la tab transitoria di window.open (che resta visibile su export voluminosi).
 */
export function scaricaFile(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = '';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
}
